import { NotAllowedIcon } from "@chakra-ui/icons";
import { Button, Center, GridItem, Text } from "@chakra-ui/react";
import { Link } from "wouter";

import { Scenario, isReadyStatus } from "@nens/ldo/api-v1";

import { ScenarioStatus } from "../scenario-status/scenario-status";

export function ExportListItem({
  scenario,
  removeAllowed,
  removeScenario,
  removeDisabled,
}: {
  scenario: Scenario;
  removeAllowed: boolean;
  removeScenario: () => void;
  removeDisabled: boolean;
}) {
  return (
    <>
      <GridItem>
        <Link to={`/scenarios/${scenario.id}`}>
          {scenario.name} ({scenario.id})
        </Link>
      </GridItem>
      <GridItem>
        {scenario.floodingFrequency ? <Text>1 / {scenario.floodingFrequency}</Text> : null}
      </GridItem>
      <GridItem>{!isReadyStatus(scenario.status) ? <NotAllowedIcon /> : null}</GridItem>
      <GridItem>
        <Center>
          <ScenarioStatus status={scenario.status} />
        </Center>
      </GridItem>
      <GridItem>
        {removeAllowed ? (
          <Button variant="outline" size="sm" onClick={removeScenario} isDisabled={removeDisabled}>
            Remove
          </Button>
        ) : null}
      </GridItem>
    </>
  );
}
